<template>
  <div class="innerBox">
    <h2 class="mb-4">User Management</h2>

    <vue-universal-table
      api_url="/api/v1/users"
      :update="vue_universal_table.update"
      :special_buttons="vue_universal_table.special_buttons"
      :buttons="vue_universal_table.buttons"
      @onUserBaru="modal.new = true"
      @onEdit="editUser"
      @onDelete="deleteUser"
    ></vue-universal-table>

    <new-user
      v-if="modal.new"
      @updateTable="vue_universal_table.update++"
      @closeModal="modal.new = false"
    ></new-user>

    <edit-user
      v-if="modal.edit"
      :editData="editData"
      @updateTable="vue_universal_table.update++"
      @closeModal="modal.edit = false"
    ></edit-user>

  </div>
</template>

<script>
  import newUser from './children/newUser'
  import editUser from './children/editUser'

  export default {
    data () {
      return {
        modal : {
          new : false,
          edit : false,
        },
        options : {

        },
        vue_universal_table : {
          update : 0,
          special_buttons : ['userBaru'],
          buttons : [
            {
              title : 'Edit',
              class : 'btn-outline-primary fa fa-edit'
            },
            {
              title : 'Delete',
              variable : 'id',
              class : 'btn-outline-danger fa fa-times'
            }
          ]
        },
        editData : null,
      }
    },
    components : {
      newUser,
      editUser,
    },
    mounted () {
      this.fetchRoleOptions();
    },
    methods : {
      fetchRoleOptions(){
        this.$http.get('/api/v1/roles')
        .then((resp)=>{
          this.options.roles = resp.data.data;
        })
        .catch((err)=>{console.log(err);})
      },
      deleteUser(id){
        this.$http.delete(`/api/v1/users/${id}`)
        .then((resp)=>{
          console.log(resp);
          this.$store.dispatch('triggerAlert', [true, ['User telah berhasil dihapus']]);
          this.vue_universal_table.update++;
        })
        .catch((err)=>{console.log(err);})
      },
      editUser(x){
        this.editData = JSON.parse(x)
        this.modal.edit = true;
      }
    }
  }
</script>

<style scoped>
  
</style>